import { MarketSegmentEnum } from '../types';

/**
 * This function is responsible for getting the market segment.
 * @returns The market segment as a string.
 */
export function getMarketSegment(): string {
    return window.location.href.includes('amigo') ? MarketSegmentEnum.AMIGO : MarketSegmentEnum.VODAFONE;
}
